import ResizeObserver from 'resize-observer-polyfill';
import debounce from 'lodash/debounce';
var observer = null;
var callbacks = new Map();
export var handleResize = function handleResize(entries) {
  for (var i = 0; i < entries.length; i++) {
    var target = entries[i].target;
    /** Get callback for target node */
    var cb = callbacks.get(target);
    /** use getBoundingClientRect to include padding */
    if (cb) {
      cb(target.getBoundingClientRect());
    }
  }
};
export var useResizeObserver = function useResizeObserver() {
  if (!observer) {
    observer = new ResizeObserver(handleResize);
  }
  return {
    observe: function observe(node, callback) {
      callbacks.set(node, debounce(callback, 10));
      // start observing after callback has been set
      observer.observe(node);
    },
    unobserve: function unobserve(node) {
      observer.unobserve(node);
      callbacks["delete"](node);
    }
  };
};